import { useQuery } from '@tanstack/react-query';
import { fetchShipmentRoutingUsersList } from '../../data-provider/users-by-customer';
import type { UsersByCustomerRequestParams } from '../../data-provider/users-by-customer/api';

export const useGetUsersByCustomer = (params: UsersByCustomerRequestParams) => {
  return useQuery({
    queryKey: ['shipment-routing-users', params.Carrierkey],
    queryFn: () => fetchShipmentRoutingUsersList(params),
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled: !!params.Carrierkey,
  });
};
